import React from "react";
import LesserOrGreaterSign from './LesserOrGreaterSign.js'
import InfoToolTip from "../InfoTooltip.js";

export default function Class1Table(props) {
    const formatMoney = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0, //round to nearest dollar
    });
    const parcelNums = props.res.map(p => p.pnum).join(" & ")
    const billtv = props.res.map(p => p.bill_tv).reduce((a, b) => a + b, 0)
    const tvLand = props.res.map(p => p.tv_land).reduce((a, b) => a + b, 0)
    const lastTaxBill = props.res.map(p => p.bill).reduce((a, b) => Math.round(a) + Math.round(b), 0) //correct rounding
    const finalLVTBill = props.res.map(p => p.final_lvt_bill_c).reduce((a, b) => a + b, 0)
    const taxBillChange = finalLVTBill - lastTaxBill
    const isGreater = lastTaxBill < finalLVTBill
    const isLesser = lastTaxBill > finalLVTBill
    
    return (
        <div>
            <table className="mx-auto mt-1">
                <tbody>
                    {(props.address && <tr className="border border-city-white border-solid">
                        <td className="bg-city-green-dark text-city-white">Address</td>
                        <td className="bg-city-green-dark/70 text-city-white">{props.address}</td>
                    </tr>)}
                    <tr className="border border-city-white border-solid">
                        <td className="bg-city-green-dark text-city-white">Parcel Number(s)</td>
                        <td className="bg-city-green-dark/70 text-city-white">{parcelNums}</td>
                    </tr>
                    <tr className="border border-city-white border-solid">
                        <td className="bg-city-green-spirit">Assessor Taxable Value</td>
                        <td className="bg-city-green-spirit/70 text-right">{formatMoney.format(billtv)}</td>
                    </tr>
                    <tr className="border border-city-white border-solid">
                        <td className="bg-city-green-light">Taxable Value of Land</td>
                        <td className="bg-city-green-light/70 text-right">{formatMoney.format(tvLand)}</td>
                    </tr>
                    <tr className="border border-city-white border-solid">
                        <td className="bg-city-green-light">
                            <div className="flex justify-center">
                                <div>Total 2023 Taxes</div>
                                <div className="ml-1"><InfoToolTip content="This is Summer and Winter. This doesn't include the solid waste fee." /></div>
                            </div>
                        </td>
                        <td className="bg-city-green-light/70 text-right">{formatMoney.format(lastTaxBill)}</td>
                        
                    </tr>
                    <tr className="border border-city-white border-solid">
                        <td className="bg-city-green-light">Estimated 2023 Taxes (LVT Plan)</td>
                        <td className="bg-city-green-light/70">
                            <div className="flex justify-center">
                                <div className="mr-auto"><LesserOrGreaterSign isGreater={isGreater} isLesser={isLesser} /></div>
                                <div>{formatMoney.format(finalLVTBill)}</div>
                            </div>
                        </td>
                    </tr>
                    <tr className="font-bold border border-city-white border-solid">
                        <td className="bg-city-yellow-tint">Tax Bill Change</td>
                        <td className="bg-city-yellow-tint/70 text-right">{isGreater && "+ "}{formatMoney.format(taxBillChange)}</td>
                    </tr>
                </tbody>
            </table>
            <div className="text-xs mb-2">This is not a tax bill, it is only an estimate. Actual taxes owed will be sent on the official property tax notices.</div>
            <div className="text-xs mb-2">This estimate is based on the City of Detroit Assessor's Office data as of June 30th, 2023, and your tax bill may vary if there have been any adjustments or changes since then.</div>
            <div className="text-xs mb-2">If you have additional questions about your property, please contact <a className="underline" href="mailto:LandValueTax@detroitmi.gov">LandValueTax@detroitmi.gov</a>.</div>
        </div>
    )
}